var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContactAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.66113,56.75h.001a5.41044,5.41044,0,0,0,4.86035-3.02148A30.75836,30.75836,0,0,0,41.05957,9.26807a30.75026,30.75026,0,1,0-1.47266,61.47949c.13965.002.27832.00244.418.00244a30.45733,30.45733,0,0,0,18.44824-6.15039l-.90039-1.19922a28.77679,28.77679,0,0,1-17.94628,5.84717A29.23732,29.23732,0,1,1,66.18066,53.05811,3.91993,3.91993,0,0,1,62.66211,55.25h-.001A3.9156,3.9156,0,0,1,58.75,51.33936V24h-1.5v8.65839a18.75,18.75,0,1,0,0,14.68322v3.99775A5.41724,5.41724,0,0,0,62.66113,56.75ZM40,57.25A17.25,17.25,0,1,1,57.25,40,17.26949,17.26949,0,0,1,40,57.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactAction);
export default __webpack_public_path__ + "static/media/icon_contact_action.5daefc46ea068e0f9502cbd648609f90.svg";
export { ForwardRef as ReactComponent };